import ReceiptLayout from '@/components/MedicalReceipt/ReceiptLayout';
import { Button } from '@successmode-ktp/kui';
import { AirportSelection } from '@repo/components';
import { useState } from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { routes } from '@/constant/routes.const';
import { useAppDispatch, useAppSelector } from '@/hooks/useReduxHooks';
import { IGlobalState } from '@/store';
import { OpenObserveRequest } from '@/types/common.type';
import { useMutation } from 'react-query';
import { sendLogToOpenObserve } from '@/api';
import { generateUUIDv7, isRefundableAirport } from '@repo/utils';

function MedicalSelectAirport() {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const {
    nationality,
    passportNumber,
    departureDate,
    isCashPickup,
    isUploadRequired,
  } = useAppSelector((state) => state as IGlobalState);
  const [selectedAirport, setSelectedAirport] = useState('');
  const isDeparture = localStorage.getItem('departureCheck') === 'yes';

  const onNextPage = () => {
    passportNumber && localStorage.setItem(passportNumber, selectedAirport);

    // @ts-ignore
    if (import.meta.env.MODE !== 'development') {
      onAddLog();
    }

    dispatch({
      type: 'UPDATE_USER_INFO',
      payload: {
        needToLogAirport: true,
      },
    });

    const isTransferWeb = localStorage.getItem(`${passportNumber}-transfer`);
    if (isTransferWeb === 'true') {
      if (departureDate) {
        history.push({
          pathname: routes.medicalHome,
        });
      } else {
        history.push({
          pathname: routes.medicalDeparture,
        });
      }
      return;
    }

    if (isDeparture && isUploadRequired) {
      if (departureDate) {
        history.push({
          pathname: routes.medicalHome,
        });
      } else {
        history.push({
          pathname: routes.medicalDeparture,
        });
      }
      return;
    }

    if (isRefundableAirport(selectedAirport)) {
      history.push(`${routes.medicalAirport}`);
      return;
    } else if (isCashPickup) {
      if (departureDate) {
        history.push({
          pathname: routes.medicalCashPickupIntro,
        });
      } else {
        history.push({
          pathname: routes.medicalDeparture,
        });
      }
      return;
    }
    if (isUploadRequired) {
      if (departureDate) {
        history.push({
          pathname: routes.medicalForceTypeProcedure,
        });
      } else {
        history.push({
          pathname: routes.medicalDeparture,
        });
      }
      return;
    }

    history.push(`${routes.medicalAirportNonRefundable}`);
  };

  const { mutate: mutateSendLogToOpenObserve } = useMutation({
    mutationFn: (payload: OpenObserveRequest) => sendLogToOpenObserve(payload),
  });

  const onAddLog = () => {
    const body = `여권번호=${passportNumber}, 국적=${nationality}, 공항=${selectedAirport}`;

    mutateSendLogToOpenObserve({
      body,
      category: 'airport-selection',
      trace_id: generateUUIDv7(),
      dataForLog: {
        passportNumber: passportNumber || '',
        airport: selectedAirport || '',
        type: 'MEDICAL',
      },
    });

    dispatch({
      type: 'UPDATE_USER_INFO',
      payload: {
        needToLogAirport: false,
      },
    });
  };

  const nationIndex = nationality === 'KOR' ? 1 : 0;
  const text = {
    next: ['Next', '다음으로'],
  };

  return (
    <ReceiptLayout>
      <Content>
        <AirportSelection
          selectedAirport={selectedAirport}
          onSelect={setSelectedAirport}
          nationality={nationality}
        />
      </Content>
      <Button
        onClick={onNextPage}
        disabled={selectedAirport === ''}
        style={
          selectedAirport === ''
            ? {
                backgroundColor: '#d3e2fd',
                marginBottom: '36px',
              }
            : undefined
        }
        size='lg'
      >
        {text.next[nationIndex]}
      </Button>
    </ReceiptLayout>
  );
}

const Content = styled.div`
  width: 100%;
`;

export default MedicalSelectAirport;
